import { CustomerAccount, CustomerAddress } from './common';

/**
 * Body of `POST .../construction-sites` and `PATCH .../construction-sites/{id}`.
 * Every field is technically optional — which ones are mandatory is configured per
 * installation and only reported back as a validation error. On `PATCH` an omitted
 * field stays unchanged; `null` means "do not change" (a field cannot be cleared).
 * Customer number and subnumber are assigned by the backend and never sent.
 */
export interface ConstructionSiteRequest {
  salutation?: string;
  name1?: string;
  name2?: string;
  name3?: string;
  /** Kurzbezeichnung — `account.name` in the customer GET. */
  name?: string;
  street?: string;
  streetNumber?: string;
  countryCode?: string;
  postCode?: string;
  city?: string;
  poBox?: string;
  telephoneNumber?: string;
  fax?: string;
  mail1?: string;
  clerk1?: string;
  clerk2?: string;
  clerk3?: string;
  /** Without the invoicing customer's prefix — the backend prepends it. */
  costCenter?: string;
  federalOrderReference?: string;
  vatId?: string;
  /** `yyyy-MM-dd`. */
  deletionDate?: string;
  bankId?: string;
  bankAccount?: string;
  representativeId?: string;
  deliveryHint?: string;
  customerDeliveryHint?: string;
}

/** Response of both construction-site endpoints — the id only, no master data. */
export interface ConstructionSiteResponse {
  /** Id of the construction-site customer; usable wherever a customer id is. */
  customerId: string;
}

/** Entry of `GET .../delivery-customers`. `account.id` is the construction site id. */
export interface DeliveryCustomer {
  account: CustomerAccount;
  deliveryAddress?: CustomerAddress;
}

/**
 * Error body of the construction-site endpoints. They answer every failure with
 * HTTP 400 (there is no 404) and ship only the translation `key` — the message is
 * assembled on the client.
 */
export interface ConstructionSiteError {
  key: string;
  params?: Record<string, unknown>;
}

export const CONSTRUCTION_SITE_ERROR_CUSTOMER_NOT_FOUND =
  'CUSTOMER.CONSTRUCTION_SITE.CUSTOMER_NOT_FOUND';
export const CONSTRUCTION_SITE_ERROR_NOT_FOUND = 'CUSTOMER.CONSTRUCTION_SITE.NOT_FOUND';
export const CONSTRUCTION_SITE_ERROR_NOT_A_SUBCUSTOMER =
  'CUSTOMER.CONSTRUCTION_SITE.NOT_A_SUBCUSTOMER';
export const CONSTRUCTION_SITE_ERROR_EDIT_NOT_ALLOWED =
  'CUSTOMER.CONSTRUCTION_SITE.EDIT_NOT_ALLOWED';
export const CONSTRUCTION_SITE_ERROR_CREATE_EXCEPTION =
  'CUSTOMER.CONSTRUCTION_SITE.CREATE.EXCEPTION';
export const CONSTRUCTION_SITE_ERROR_UPDATE_EXCEPTION =
  'CUSTOMER.CONSTRUCTION_SITE.UPDATE.EXCEPTION';
